// removed by extract-text-webpack-plugin
module.exports = {"container":"_1chiI","content":"_32Zgm","code":"_1wfiq","title":"_3moCQ","text":"_1gkwi"};


//////////////////
// WEBPACK FOOTER
// ./src/ErrorPage/ErrorPage.css
// module id = 486
// module chunks = 3